<template>
  <div class="layout-cart">
    <div class="container">
      <div class="middle-title">
        <slot name="title"></slot>
      </div>
      <div class="sides">
        <layout-cart-products
          :total="total"
          :subtotal="subtotal"
          :cart="cart"
          :products="products"
        ></layout-cart-products>
        <layout-cart-checkout :order="order">
          <slot slot="agreement" name="agreement"></slot>
          <slot slot="promos" name="promos"></slot>
        </layout-cart-checkout>
      </div>
    </div>
  </div>
</template>

<script>
import layoutCartProducts from '@/components/layout/cart/layout-cart-products'
import layoutCartCheckout from '@/components/layout/cart/layout-cart-checkout'
export default {
  components: {
    layoutCartProducts,
    layoutCartCheckout
  },
  data() {
    return {
      cart: window.__cart__ || {},
      order: window.__cart__.order || {}
    }
  },
  computed: {
    products() {
      return this.cart.products || []
    },
    shipping() {
      return this.cart.shipping || 0
    },
    subtotal() {
      let summ = 0
      for (const product of this.products) {
        summ = summ + product.price * product.count
      }
      return summ
    },
    total() {
      return this.subtotal + this.shipping
    }
  }
}
</script>

<style lang="scss" scoped>
.layout-cart {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  padding-bottom: 4em;
  .container {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }
}
.sides {
  flex-grow: 1;
  display: flex;
  margin-top: 2em;
  & > * {
    flex-grow: 1;
    &:nth-child(1) {
      flex-basis: 140%;
      margin-right: 3em;
    }
    &:nth-child(2) {
      flex-basis: 100%;
    }
  }
}
@media screen and (max-width: 767px) {
  .sides {
    display: block;
    & > * {
      &:nth-child(1) {
        margin-right: 0em;
        margin-bottom: 3em;
      }
    }
  }
}
</style>
